var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordSuccessIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160,
    height: 154,
    viewBox: "0 0 160 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc886"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29225",
    "data-name": "Group 29225",
    transform: "translate(-21529.16 17403.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3925",
    "data-name": "Ellipse 3925",
    transform: "translate(21535.16 -17403.992)",
    fill: "rgba(250,156,43,0.1)",
    stroke: "#fa9c2b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 77,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 76.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3926",
    "data-name": "Ellipse 3926",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(21546.16 -17400.992)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3927",
    "data-name": "Ellipse 3927",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(21670.16 -17273.992)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3928",
    "data-name": "Ellipse 3928",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(21529.16 -17293.992)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3929",
    "data-name": "Ellipse 3929",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(21555.16 -17331.992)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3930",
    "data-name": "Ellipse 3930",
    cx: 4.5,
    cy: 5,
    rx: 4.5,
    ry: 5,
    transform: "translate(21658.16 -17386.992)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14533",
    "data-name": "Path 14533",
    d: "M88.169,56.736H83.931V44.726a24.726,24.726,0,0,0-49.453,0v12.01H31.652A5.652,5.652,0,0,0,26,62.388V99.125a5.652,5.652,0,0,0,5.652,5.652H88.169a5.652,5.652,0,0,0,5.652-5.652V62.388A5.652,5.652,0,0,0,88.169,56.736ZM64.149,86.408a4.239,4.239,0,1,1-8.478,0V75.1a4.239,4.239,0,1,1,8.478,0ZM42.955,56.736V44.726a16.249,16.249,0,0,1,32.5,0v12.01Z",
    transform: "translate(21552.332 -17395.699)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29224",
    "data-name": "Group 29224",
    transform: "translate(21628.691 -17313.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14534",
    "data-name": "Path 14534",
    d: "M14.467,29.934a1.484,1.484,0,0,1-.4-.062A17.628,17.628,0,0,1,2,13.116V5a1.247,1.247,0,0,1,.848-1.247L14.068.013a1.247,1.247,0,0,1,.8,0l11.22,3.74A1.247,1.247,0,0,1,26.934,5v8.116A17.628,17.628,0,0,1,14.866,29.934,1.483,1.483,0,0,1,14.467,29.934Z",
    transform: "translate(-1.53 0.152)",
    fill: "#0faa51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14535",
    "data-name": "Path 14535",
    d: "M11.612,17.224a1.153,1.153,0,0,1-.819-.334L7.335,13.431a1.158,1.158,0,0,1,1.637-1.637l2.64,2.652,6.1-6.11a1.158,1.158,0,1,1,1.637,1.637l-6.917,6.917A1.153,1.153,0,0,1,11.612,17.224Z",
    transform: "translate(-0.527 2.103)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSuccessIconDark);
export default __webpack_public_path__ + "static/media/password_success_icon_dark.0d9fcdf1c8c155a3b5041fa26388ea56.svg";
export { ForwardRef as ReactComponent };